import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import FormattedDescription from "./FormattedDescription";

function ProductModalWithButton({
  productDescription,
  productId,
  productName,
}) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div id={`productModal${productId}`} className="float-end">
      <Button className="btn-product-info" onClick={handleShow}>
        i
      </Button>
      <Modal
        id={`productModal${productId}`}
        show={show}
        onHide={handleClose}
        centered
        size="lg"
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>
            <strong>{productName}</strong>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormattedDescription description={productDescription} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ProductModalWithButton;
